import { GwDatesWrapper } from '../../../_internal_date_/gwDatesWrapper';
import { DATE_FORMATS } from '../../../../utilities/constants';
import { canadianEmailAddressRegex, canadianPostalCodeRegex } from '../../../../utilities/guestsUtils';
import { editCopyByReplaceMultipleStrings } from '../../../utilities/copyFunctions';
import * as COPY from '../../utilities/copy';

export const isCanadianEmail = email => {
  if (!email) return false;
  return canadianEmailAddressRegex.test(email);
};

export const isCanadianPostalCode = postalCode => {
  if (!postalCode) return false;

  return canadianPostalCodeRegex.test(postalCode);
};

export const getCancellationPolicyDate = (isArrivalTodayOrTomorrow, isRefundable, checkinDateSelection) => {
  if (isArrivalTodayOrTomorrow && isRefundable) return undefined;

  const date = !isRefundable
    ? GwDatesWrapper.add(GwDatesWrapper.today(), 1, 'days')
    : GwDatesWrapper.subtract(checkinDateSelection, 1, 'days');

  return GwDatesWrapper.format(date, DATE_FORMATS.monthLongDayCommaYear);
};

export const getCancellationPolicyCopy = ({
  checkinDateSelection,
  isRefundable,
  isChangedToFlex,
  isFareFamilyFourRatesCase
}) => {
  const arrivalDate = GwDatesWrapper.format(checkinDateSelection, DATE_FORMATS.monthLongDayCommaYear);
  const isArrivalTodayOrTomorrow =
    GwDatesWrapper.isToday(checkinDateSelection) || GwDatesWrapper.isTomorrow(checkinDateSelection);
  const cancellationDate = getCancellationPolicyDate(isArrivalTodayOrTomorrow, isRefundable, checkinDateSelection);
  const tomorrowDate = GwDatesWrapper.format(
    GwDatesWrapper.add(GwDatesWrapper.today(), 1, 'days'),
    DATE_FORMATS.monthLongDayCommaYear
  );

  if (isFareFamilyFourRatesCase) {
    return isChangedToFlex || isRefundable
      ? editCopyByReplaceMultipleStrings(COPY.CANCELLATION_TEXT_FLEXIBLE, {
          '<DATE>': arrivalDate,
          '<DATE2>': arrivalDate
        })
      : editCopyByReplaceMultipleStrings(COPY.CANCELLATION_TEXT_STANDARD, { '<DATE>': tomorrowDate });
  }

  const defaultDate = isRefundable ? arrivalDate : cancellationDate;
  return editCopyByReplaceMultipleStrings(COPY.CANCELLATION_TEXT_DEFAULT, {
    '<DATE>': defaultDate,
    '<DATE2>': defaultDate
  });
};
